import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Row,
  Col,
  Card,
  CardBody,
  CardFooter,
} from "reactstrap";
import { toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  updatePromoCode,
  createPromoCode,
} from "../../redux/actions/promoCodes";
import { STATUS_LABELS } from "../../constants";

toast.configure();

const PromoCodeForm = (props) => {
  const promoCode = props.promoCode;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  console.log("props.promoCode", props.promoCode);

  const [currentPromoCodeInfo, setCurrentPromoCodeInfo] = useState({});
  const [codeErr, setCodeErr] = useState("");
  const [categoryErr, setCategoryErr] = useState("");
  const [amountErr, setAmountErr] = useState("");

  if (JSON.stringify(promoCode) !== "{}" && !currentPromoCodeInfo.id) {
    setCurrentPromoCodeInfo(promoCode);
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCurrentPromoCodeInfo({ ...currentPromoCodeInfo, [name]: value });
  };

  const handleValidation = (event) => {
    const inputValue = event.target.value.trim();
    const inputFieldName = event.target.name;

    if (inputFieldName === "code") {
      if (inputValue.length < 2) {
        setCodeErr("Please enter at least 2 characters!");
      } else {
        setCodeErr("");
      }
    }

    if (inputFieldName === "amount") {
      if (!inputValue || isNaN(inputValue) || Number(inputValue) <= 0) {
        setAmountErr("Please enter a valid positive amount!");
      } else {
        setAmountErr("");
      }
    }
  };

  const submitHandler = (event) => {
    event.preventDefault();

    let errorCount = 0;
    const formData = new FormData();

    if (
      JSON.stringify(currentPromoCodeInfo) === "{}" ||
      !currentPromoCodeInfo.code ||
      currentPromoCodeInfo.code.length < 2
    ) {
      setCodeErr("Please enter at least 2 characters!");
      errorCount++;
    } else {
      formData.append("code", currentPromoCodeInfo.code);
      setCodeErr("");
    }

    if (
      JSON.stringify(currentPromoCodeInfo) === "{}" ||
      !currentPromoCodeInfo.categoryId
    ) {
      setCategoryErr("Please select Promo Code!");
      errorCount++;
    } else {
      formData.append("categoryId", currentPromoCodeInfo.categoryId);
      setCategoryErr("");
    }

    if (
      !currentPromoCodeInfo.amount ||
      isNaN(currentPromoCodeInfo.amount) ||
      Number(currentPromoCodeInfo.amount) <= 0
    ) {
      setAmountErr("Please enter a valid positive amount!");
      errorCount++;
    } else {
      formData.append("amount", currentPromoCodeInfo.amount);
      setAmountErr("");
    }

    if (errorCount > 0) {
      return;
    } else {
      if (JSON.stringify(props.promoCode) !== "{}") {
        dispatch(updatePromoCode(currentPromoCodeInfo.id, formData))
          .then(() => {
            setCurrentPromoCodeInfo({ ...currentPromoCodeInfo });
            toast("Promo Code updated successfully!", {
              transition: Slide,
              closeButton: true,
              autoClose: 3000,
              position: "top-right",
              type: "success",
            });
          })
          .catch((error) => {
            toast(error.response.data.message, {
              transition: Slide,
              closeButton: true,
              autoClose: 3000,
              position: "top-right",
              type: "error",
            });
          });
      } else {
        dispatch(createPromoCode(formData))
          .then((response) => {
            toast("Promo Code created successfully!", {
              transition: Slide,
              closeButton: true,
              autoClose: 1000,
              position: "top-right",
              type: "success",
            });

            navigate(`/storageType/${response.storageTypeInfo.id}`);
          })
          .catch((error) => {
            toast(error, {
              transition: Slide,
              closeButton: true,
              autoClose: 3000,
              position: "top-right",
              type: "error",
            });
          });
      }
    }
  };

  console.log("currentPromoCodeInfo", currentPromoCodeInfo);

  return (
    <>
      {currentPromoCodeInfo ? (
        <Row>
          <Col md="12">
            <Card className="main-card mb-3">
              <Form>
                <CardBody>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label for="code">Code</Label>
                        <Input
                          invalid={codeErr !== ""}
                          type="text"
                          name="code"
                          id="code"
                          placeholder="Code here..."
                          value={currentPromoCodeInfo.code || ""}
                          onChange={handleInputChange}
                          onKeyUp={handleValidation}
                        />
                        {codeErr && <FormFeedback>{codeErr}</FormFeedback>}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label for="amount">Amount ($)</Label>
                        <Input
                          invalid={amountErr !== ""}
                          type="number"
                          name="amount"
                          id="amount"
                          placeholder="Amount in dollars"
                          min="0"
                          value={currentPromoCodeInfo.amount || ""}
                          onChange={handleInputChange}
                          onKeyUp={handleValidation}
                        />
                        {amountErr && <FormFeedback>{amountErr}</FormFeedback>}
                        {currentPromoCodeInfo.amount && Number(currentPromoCodeInfo.amount) > 0 && (
                          <small className="text-muted">
                            Equivalent to {Math.round(Number(currentPromoCodeInfo.amount) * 100).toLocaleString()} Reward Points
                          </small>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <FormGroup>
                      <Label for="categoryId">Code Type</Label>
                      <Input
                        invalid={categoryErr !== ""}
                        id="categoryId"
                        name="categoryId"
                        type="select"
                        value={currentPromoCodeInfo.categoryId || ""}
                        onChange={(event) => {
                          handleInputChange(event);
                          handleValidation(event);
                        }}
                      >
                        <option value={""}>Select Category</option>
                        {STATUS_LABELS.map((category, index) => (
                          <option key={index} value={category.value}>
                            {category.label}
                          </option>
                        ))}
                      </Input>
                      {categoryErr && (
                        <FormFeedback>{categoryErr}</FormFeedback>
                      )}
                    </FormGroup>
                  </Row>
                </CardBody>
                <CardFooter className="d-block">
                  <Button
                    className="me-2"
                    color="link"
                    onClick={() => {
                      navigate(`/promoCodes/list`);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button size="lg" color="primary" onClick={submitHandler}>
                    {JSON.stringify(props.promoCode) !== "{}"
                      ? "Update"
                      : "Save"}
                  </Button>
                </CardFooter>
              </Form>
            </Card>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col md="12">
            <Card className="main-card mb-3">
              <p>You are not authorized to access the page!</p>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default PromoCodeForm;
